import { BCMSCurrency, DisabledPrompt, useWorkflowStep } from "@bcm-dev/bcms-vite";
import { getDefaultMultiPay, getWorkflowSteps } from "compid/workflows/MultiPay";

import ButtonContainer from "compid/shared/containers/ButtonContainer";
import PageLayoutContainer from "compid/shared/containers/PageLayoutContainer";
import CenterColumnContainer from "compid/shared/containers/PageLayoutContainer/containers/CenterColumnContainer";
import PageView from "compid/shared/containers/PageViewContainer";
import UIButton from "compid/ui/UIButton";
import { SVGAsset } from "res";
import MultipayConfirmationWidget from "./components/MultipayConfirmationWidget";

import { Link } from "@mui/material";
import "./styles.css";

export default function MultipayConfirmationPage(props) {
    
    const workflowStep = useWorkflowStep(getDefaultMultiPay, getWorkflowSteps);
    const items = workflowStep.read("items");

    const multipayItems = items.map(item => <MultipayConfirmationWidget key={ `Confirmation_${ item.bill.id }` } multipay={ item } />, []);
    
    const totalAmount = items.reduce((result, item) => {
        return result += parseFloat(item.amount.amount) + parseFloat(item.feeAmount.amount);
    }, 0);

    const submit = evt => workflowStep.navigate("/payBills");

    return (
        <PageView className="multipay-confirmation-page">
            <p className="page-sub-header semi-bold-text flex-container flex-horizontal">
                <span className="flex-width">PAYMENT CONFIRMATION</span>
                <DisabledPrompt>
                    <Link to="/" className="flex-container flex-horizontal align-center set-width link print-link">
                        <SVGAsset id="PrinterIcon" className="left-icon" />
                        <p data-point="Activity_Filter_Print">Print</p>
                    </Link>
                </DisabledPrompt>
            </p>

            <PageLayoutContainer>
                <div className="flex-container flex-vertical flex-width">
                    <div className="flex-height flex-width flex-container all-center">
                        <CenterColumnContainer>
                            <div className="form-group">
                                <div className="flex-container flex-vertical all-center form-row">
                                    <SVGAsset id="CheckmarkIcon" className="green-icon" />
                                    <p className="gray-text">You've scheduled { items.length } payments for a total of { BCMSCurrency.toCurrency(totalAmount) }</p>
                                </div>

                                <div className="form-row multipay-items">
                                    { multipayItems }
                                </div>

                                <ButtonContainer className="form-button-container">
                                    <UIButton onClick={ submit } className="primary-button" dataPoint="Payment_Confirmation_Done">Done</UIButton>
                                </ButtonContainer>
                            </div>
                        </CenterColumnContainer>
                    </div>
                </div>
            </PageLayoutContainer>
        </PageView>
    );
}